// SPDX-License-Identifier: EUPL-1.2
/*
 * Copyright (c) 2025, European Commission. Licensed under the EUPL-1.2
 * Authors:
*   Pierluigi Spedicato
 */

import App from '@app/App';
import MainProvider from '@app/MainProvider';
import '@app/shared/charts/ChartsProps';
import '@src/i18n';
import '@theme/styles/global.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

const root = document.getElementById('root');
if (!!root) {
	createRoot(root).render(
		// <StrictMode>
		<BrowserRouter>
			<MainProvider>
				<App standalone={true} />
			</MainProvider>
		</BrowserRouter>
		// </StrictMode>
	);
} else {
	throw new Error('Root element not found');
}
